module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "lxm-transition-fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "lxm-register-dialog-container"
  }, [_c('div', {
    staticClass: "lxm-register-dialog"
  }, [_c('div', {
    staticClass: "lxm-register-content"
  }, [_c('div', {
    staticClass: "lxm-register-title"
  }, [_c('span', [_vm._v("恭喜")]), _vm._v(" 您成功注册灵析")]), _vm._v(" "), _vm._l((_vm.registerData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "lxm-register-row"
    }, [_c('span', {
      staticClass: "lxm-register-text"
    }, [(item.isRequired) ? _c('span', {
      staticClass: "lxm-register-text-required"
    }, [_vm._v(" * ")]) : _vm._e(), _vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "lxm-register-input-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "lxm-register-input",
      attrs: {
        "type": "text",
        "placeholder": item.placeholder
      },
      domProps: {
        "value": _vm._s(item.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.value = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "lxm-register-input-tip"
    }, [_vm._v(_vm._s(item.tip))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-register-button"
  }, [_c('span', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("开启灵析")])])], 2)])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e23d52c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e23d52c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LxmRegisterDialog.vue
// module id = 831
// module chunks = 0